const accountsInitialState = {
  accounts: null,
  shouldFetchAccounts: false
};

export default accountsInitialState;
